import React from 'react'
import elevation from "../images/exterior 1.jpg.jpeg";
import maingateSRGCOMPLEX from "../images/main gate srg.jpg";
import WATERdesign from "../images/Water Design.jpg";
import villa3bhk from "../images/3BHK Villa Photo.jpg"
import villa2bhk from "../images/4 BHK VILLA photo.jpg";
import landforsale from "../images/Land Photo.jpg";

function Slider() {
  return (
    <div>
      <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="5" aria-label="Slide 6"></button>



  </div>
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img src={maingateSRGCOMPLEX} className="d-block w-100" alt="SRG Complex"/>
    </div>
       <div className="carousel-item">
      <img src={WATERdesign} className="d-block w-100" alt="Best House Property in Krishnagar"/>
    </div>
    <div className="carousel-item">
      <img src={elevation} className="d-block w-100" alt="Best House Property in Krishnagar"/>
    </div>
    <div className="carousel-item">
      <img src={villa3bhk} className="d-block w-100" alt="villa3bhk Krishnagar"/>
    </div>
     <div className="carousel-item">
      <img src={villa2bhk} className="d-block w-100" alt="villa2bhk Krishnagar"/>
    </div>
       <div className="carousel-item">
      <img src={landforsale} className="d-block w-100" alt="villa2bhk Krishnagar"/>
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default Slider